import { render, staticRenderFns } from "./MobilePhonePackagesAdd.vue?vue&type=template&id=46ad0d74&"
import script from "./MobilePhonePackagesAdd.vue?vue&type=script&lang=js&"
export * from "./MobilePhonePackagesAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./MobilePhonePackagesAdd.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports